export default __webpack_public_path__ + "static/media/active-step.71b83150.svg";